module.exports = __webpack_public_path__ + "img/play.a171eb4b.svg";